import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function generatePageSchema(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/generate_page_schema`)
}

export function getPageSchema(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/page_schema`)
}

export function updateSchemaInputs(pageId, userInputs) {
  return axios.post(`/ajax/website_pages/${pageId}/update_schema_inputs`, { user_inputs: userInputs })
}

export function approvePageSchema(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/approve_page_schema`)
}
